/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DesignSurfaceInfiltration
 */
export interface DesignSurfaceInfiltration {
  /**
   *
   * @type {string}
   * @memberof DesignSurfaceInfiltration
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof DesignSurfaceInfiltration
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof DesignSurfaceInfiltration
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof DesignSurfaceInfiltration
   */
  designSurfaceInfiltrationId: string | null;
  /**
   * Polygon coordinates as string
   * @type {string}
   * @memberof DesignSurfaceInfiltration
   */
  designSurfaceInfiltrationPos: string | null;
  /**
   *
   * @type {string}
   * @memberof DesignSurfaceInfiltration
   */
  installation: string;
  /**
   *
   * @type {string}
   * @memberof DesignSurfaceInfiltration
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the DesignSurfaceInfiltration interface.
 */
export function instanceOfDesignSurfaceInfiltration(
  value: object
): value is DesignSurfaceInfiltration {
  if (
    (!("designSurfaceInfiltrationId" in (value as Record<string, any>)) &&
      !("design_surface_infiltration_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["designSurfaceInfiltrationId"] === undefined &&
      (value as Record<string, any>)["design_surface_infiltration_id"] === undefined)
  )
    return false;
  if (
    (!("designSurfaceInfiltrationPos" in (value as Record<string, any>)) &&
      !("design_surface_infiltration_pos" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["designSurfaceInfiltrationPos"] === undefined &&
      (value as Record<string, any>)["design_surface_infiltration_pos"] === undefined)
  )
    return false;
  if (!("installation" in value) || value["installation"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function DesignSurfaceInfiltrationFromJSON(json: any): DesignSurfaceInfiltration {
  return DesignSurfaceInfiltrationFromJSONTyped(json, false);
}

export function DesignSurfaceInfiltrationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DesignSurfaceInfiltration {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    designSurfaceInfiltrationId: json["design_surface_infiltration_id"],
    designSurfaceInfiltrationPos: json["design_surface_infiltration_pos"],
    installation: json["installation"],
    dataOwner: json["data_owner"],
  };
}

export function DesignSurfaceInfiltrationToJSON(json: any): DesignSurfaceInfiltration {
  return DesignSurfaceInfiltrationToJSONTyped(json, false);
}

export function DesignSurfaceInfiltrationToJSONTyped(
  value?: Omit<DesignSurfaceInfiltration, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    design_surface_infiltration_id: value["designSurfaceInfiltrationId"],
    design_surface_infiltration_pos: value["designSurfaceInfiltrationPos"],
    installation: value["installation"],
    data_owner: value["dataOwner"],
  };
}
